module.exports = __webpack_public_path__ + "img/close.257b46ba.png";